import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MenuItems from './MenuItems';
import ItemsLogout from './items-logout.json';
// import { history } from '../../helpers/history';
import MenuHeader from './MenuHeader';
import Drawer from '@material-ui/core/Drawer';
import Hidden from '@material-ui/core/Hidden';
import { useTheme, makeStyles } from '@material-ui/core';
import { history } from '../../helpers/history';
import { sendMobile } from '../../functions/mobile';
// import { isMobile } from 'react-device-detect';
import { openLink } from '../../functions/core-actions';

const drawerWidth = 270;
const drawerWidthMobile = 200;

const useStyles = makeStyles((theme) => ({
  drawer: {
    // [theme.breakpoints.up('sm')]: {
    //   width: drawerWidthMobile,
    //   flexShrink: 0,
    //   backgroundColor : '#434041'
    // },
    // [theme.breakpoints.up('md')]: {
    //   width: drawerWidth,
    //   flexShrink: 0,
    //   backgroundColor : '#434041'
    // },
    // [theme.breakpoints.up('lg')]: {
    //     width: drawerWidth,
    //     flexShrink: 0,
    //     backgroundColor : '#434041'
    //   },
    // [theme.breakpoints.up('xl')]: {
    //   width: drawerWidth,
    //   flexShrink: 0,
    //   backgroundColor : '#434041'
    // },
  },
  // necessary for content to be below app bar
  toolbar: theme.mixins.toolbar,
  drawerPaper: {
    [theme.breakpoints.up('xs')]: {
      width: drawerWidthMobile,
      backgroundColor : '#0097a0'
    },
    [theme.breakpoints.up('sm')]: {
      width: drawerWidthMobile,
      backgroundColor : '#0097a0'
    },
    [theme.breakpoints.up('md')]: {
      width: drawerWidth,
      backgroundColor : '#0097a0'

    },
    [theme.breakpoints.up('lg')]: {
      width: drawerWidth,
      backgroundColor : '#0097a0'
    },
    [theme.breakpoints.up('xl')]: {
      width: drawerWidth,
      backgroundColor : '#0097a0'
    },
  }
}));

const MenuDrawerLogout = props => {
    const { open, closeDrawer, window } = props
    const classes = useStyles();
    const theme = useTheme();
    const [ menuselectedsimple, setMenuselectedsimple ] = useState("Estado de cuenta")
    const [ menuselectedcollapse, setMenuselectedcollapse ] = useState("");
    
    const sendData = (data, text) => {
      //console.log(data)
      if (data === 'WhatsApp') {
        if (localStorage.caja_app !== undefined) {
          sendMobile(JSON.stringify({
            type: 'openLink',
            data: 'https://wa.link/shd95s'
          }))
        } else {
          try {
            openLink('https://wa.link/shd95s')
          } catch (error) {
            //console.log(error)
          }
        }
        
        // window.open('https://wa.link/shd95s');
      } else {
        history.push(data)
      }
        setMenuselectedcollapse("")
        setMenuselectedsimple(text)
        open && closeDrawer()
    }

    const menuCollapseSelected = (text) => {
      //console.log(text);
      setMenuselectedsimple(text)
    }

    const submenuCollapseSelected = (data, text, textfather) => {
      setMenuselectedcollapse(text)
      setMenuselectedsimple(textfather)
      open && closeDrawer()
    }

    const container = window !== undefined ? () => window().document.body : undefined;
    return (
        <nav className={classes.drawer} aria-label="mailbox folders">
            <Hidden smUp implementation="css">
            <Drawer
                container={container}
                variant="temporary"
                anchor={theme.direction === 'rtl' ? 'right' : 'left'}
                open={open}
                onClose={closeDrawer}
                classes={{
                paper: classes.drawerPaper,
                }}
                ModalProps={{
                keepMounted: true, // Better open performance on mobile.
                }}
            >
                <MenuHeader />
                <MenuItems items = { ItemsLogout } sendData = { sendData } menuselectedsimple = { menuselectedsimple } submenuCollapseSelected = { submenuCollapseSelected } menuselectedcollapse = { menuselectedcollapse } menuCollapseSelected = { menuCollapseSelected }/>
            </Drawer>
            </Hidden>
        </nav>
    );
};

MenuDrawerLogout.propTypes = {
    open: PropTypes.bool.isRequired,
    closeDrawer: PropTypes.func.isRequired,
};

export default MenuDrawerLogout;